<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
      @search="getTableData"
    ></ots-table-group-new>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { tryExamSelectClassAPI, tryExamQueryListAPI, tryExamExportAPI } from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportInfo,
        },
      ],
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '教室名称',
          type: 'select',
          requestKey: 'classId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '试考状态',
          type: 'select',
          requestKey: 'status',
          label: 'name',
          value: 'id',
          data: [
            { id: 0, name: '未开始' },
            { id: 1, name: '未通过' },    
            { id: 2, name: '已完成' },
          ]
        },  
      ],
      pagination: {
        total: 0,
      },
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考点名称",
          prop: "placeName",
        },
        {
          title: "教室名称",
          prop: "className",
        },
        {
          title: "试考状态",
          prop: "status",
        },
        {
          title: "试考机器数量",
          prop: "needTestCount",
        },
        {
          title: "试考机器完成数量",
          prop: "testedCount",
        },
        {
          title: "试考时间",
          prop: "testBeginTime",
        }
      ],
      requestForm: {
        planId: '',
        placeId: '',
        classId: '',
        status: '',
        size: 10,
        page: 1,
      },
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.getTableData();
    },
    'requestForm.placeId': function(value) {
      this.getClass();
    },
  },
  created() {
    this.getPlan();
  },
  methods: {
    /* 
      类数组 => 数组
        (1)
          Array.from() -- 将类数组对象转换成数组
          Array.from('Hey') ==> ['H', 'e', 'y']
        (2)
          解构赋值 ==> [...类数组]

      排序 sort ==> 可以按照字母或者数字排序
        (1) 默认：sort() 按照 '字母和' 升序，将值作为字符串进行排序
        (2) 适用字符串(Apple > Banana > Cherry); 
        (3) 如果数字按照字符串排序，'25' > '100' ==> 因为 "2" > "1""
    */
    /* 
    sortAndReturnTextContent() {
      const items = document.getElementById('myList').children;
      const itemsArr = [...items].sort((a, b) => {
        return a.id > b.id ? 1: -1;
      })
      document.getElementById('myList').innerHTML = itemsArr.map(item => item.outerHTML).join('');
    }, 
    */

    // 获取批次
    async getPlan() {
      const { data: planData } = await getSelectPlanFn({needAudit: 31});
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 获取考点
    async getPlace(value) {
      const { data: placeData } = await getCurrentSelectPlace({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 获取教室
    async getClass() {
      let params = {
        planId: this.requestForm.planId,
        placeId: this.requestForm.placeId
      }
      const { data: classData } = await tryExamSelectClassAPI(params);
      if (classData.length === 0) {
        this.selectList[2].data = [];
        this.requestForm.classId = '';
        return;
      }
      this.selectList[2].data = [{id: '', name: '全部'}, ...classData];
      this.requestForm.classId = '';
    },

    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm }
      const { data: tableData } = await tryExamQueryListAPI(params);
      this.pagination.total = tableData.total;
      this.tableData = tableData.records;
    },

    // 导出
    async exportInfo() {
      let params = { ...this.requestForm };
      let result = await tryExamExportAPI(params)
      if (result.code === 1) {
        window.open(result.data);
      }
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }

}
</script>
